import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings } = FiIcons;

const Logo = ({ className = "h-16", showText = true, variant = "dark" }) => {
  const [imgError, setImgError] = useState(false);

  // Updated logo URL
  const logoSrc = "https://bikesmusicandmore.com/wp-content/uploads/2023/10/LOGO_BCB_2.png";

  const TextContainer = ({ children }) => (
    <div className={`flex flex-col justify-center ${showText ? 'ml-3' : 'hidden'}`}>
      {children}
    </div>
  );

  return (
    <div className="flex items-center">
      {/* Logo Bild */}
      {!imgError ? (
        <img
          src={logoSrc}
          alt="Bavaria Custom Bikes"
          className={`${className} w-auto object-contain filter drop-shadow-lg hover:scale-105 transition-transform duration-300`}
          onError={() => setImgError(true)}
        />
      ) : (
        /* Fallback (wird nur angezeigt, falls das Bild nicht lädt) */
        <div
          className={`relative flex items-center justify-center bg-gradient-to-br from-orange-600 to-orange-500 rounded-lg shadow-lg ${
            className.includes('h-16') ? 'w-14 h-14' : 'w-10 h-10'
          }`}
        >
          <SafeIcon
            icon={FiSettings}
            className="text-white w-3/4 h-3/4 animate-spin-slow"
            style={{ animationDuration: '10s' }}
          />
          <span className="absolute text-white font-black text-lg tracking-tighter">
            BCB
          </span>
        </div>
      )}

      {/* Text neben dem Logo */}
      <TextContainer>
        <span style={{
      color: 'rgb(255, 255, 255)'
    }}
          className={`font-bold leading-none tracking-tight ${
            variant === 'light' ? 'text-gray-900' : 'text-white'
          } ${className.includes('h-16') ? 'text-xl' : 'text-lg'}`}
        >Bavaria Custom Bikes</span>
        <span
          className={`font-medium leading-none tracking-widest text-orange-500 ${
            className.includes('h-16') ? 'text-sm' : 'text-xs'
          }`}
        >BIKES & PARTS</span>
      </TextContainer>
    </div>
  );
};

export default Logo;